"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AtomicFocus = _interopRequireDefault(require("draft-plugins/components/AtomicFocus"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _draftJs = require("draft-js");

var _EmbedModal = _interopRequireDefault(require("rich-text-lib/components/EmbedModal"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _embedSrc = require("rich-text-lib/utils/embedSrc");

var _embedDataToHtml = _interopRequireDefault(require("rich-text-lib/utils/embedDataToHtml"));

var _react = _interopRequireWildcard(require("react"));

var _constants = require("composer-plugins/lib/constants");

var _utils = require("composer-plugins/lib/utils");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIButtonGroup = _interopRequireDefault(require("UIComponents/button/UIButtonGroup"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITether = _interopRequireDefault(require("UITether/UITether"));

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _embed = require("composer-plugins/lib/embed");

var EMBED_OPTIONS_MENU_CLASSNAME = 'embed-component-options';
var OFFSET_HORIZONTAL = 15;
var OFFSET_VERTICAL = -OFFSET_HORIZONTAL;

var EmbedComponent = _react.default.createClass({
  displayName: "EmbedComponent",
  propTypes: {
    block: _react.PropTypes.object.isRequired,
    blockProps: _react.PropTypes.object.isRequired,
    contentState: _react.PropTypes.object.isRequired
  },
  contextTypes: {
    getEditorState: _react.PropTypes.func,
    getReadOnly: _react.PropTypes.func.isRequired,
    onChange: _react.PropTypes.func
  },
  getInitialState: function getInitialState() {
    return {
      showEmbedModal: false,
      showActionButtons: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _this$props = this.props,
        block = _this$props.block,
        blockProps = _this$props.blockProps;
    var embedData = this.getEntityData(block.getEntityAt(0));
    var scripts = this.getScripts(embedData);
    scripts.forEach(function (script) {
      var scriptHtml = document.createElement('script');
      var srcAttr = script.attributes.find(function (element) {
        return element.key = 'src';
      });
      scriptHtml.src = srcAttr.value;
      scriptHtml.async = true;
      document.body.appendChild(scriptHtml);
    });
    blockProps.onInsertableLoaded();
    document.body.addEventListener('click', this.handleHideActions);
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    var getCommentsOnly = nextProps.blockProps.getCommentsOnly;
    var getReadOnly = this.context.getReadOnly;
    return !getReadOnly() && !getCommentsOnly();
  },
  componentWillUnmount: function componentWillUnmount() {
    document.body.removeEventListener('click', this.handleHideActions);
    var block = this.props.block;
    var embedData = this.getEntityData(block.getEntityAt(0));
    var scripts = this.getScripts(embedData);
    scripts.forEach(function (script) {
      var srcAttr = script.attributes.find(function (element) {
        return element.key = 'src';
      });
      var scriptHtml = document.querySelector("script[src=\"" + srcAttr.value + "\"]");
      document.body.removeChild(scriptHtml);
    });
  },
  getEntityData: function getEntityData(entityKey) {
    return this.props.contentState.getEntity(entityKey).getData();
  },
  getScripts: function getScripts(embedData) {
    if (!Array.isArray(embedData)) {
      return [];
    }

    return embedData.filter(function (element) {
      return element.tag === 'script';
    });
  },
  getOriginalUrl: function getOriginalUrl(embedData) {
    if (!embedData) {
      return undefined;
    }

    if (!Array.isArray(embedData)) {
      // legacy format
      return embedData.url || embedData.originalUrl;
    } else if (embedData.length !== 1) {
      return undefined;
    }

    var attributes = embedData[0].attributes;
    var urlAttr = attributes && attributes.find(function (element) {
      return element.key === 'url' || element.key === 'originalUrl';
    });
    return urlAttr ? urlAttr.value : undefined;
  },
  handleEditEmbed: function handleEditEmbed(data) {
    var onInsertEmbedChange = this.props.blockProps.onInsertEmbedChange; // We remove the embed and re-add it again with the new data to be sure that the scripts (if any are added correctly)

    this.handleRemoveEmbed();
    onInsertEmbedChange((0, _embedSrc.getEmbedData)(data));
  },
  handleCloseModal: function handleCloseModal() {
    this.setState({
      showEmbedModal: false
    });
  },
  handleOpenModal: function handleOpenModal() {
    var block = this.props.block;
    var _this$context = this.context,
        getEditorState = _this$context.getEditorState,
        onChange = _this$context.onChange;

    var newSelection = _draftJs.SelectionState.createEmpty(block.getKey());

    onChange(_draftJs.EditorState.forceSelection(getEditorState(), newSelection));
    this.setState({
      showEmbedModal: true
    });
  },
  handleRemoveEmbed: function handleRemoveEmbed() {
    var block = this.props.block;
    var entityKey = block.getEntityAt(0);
    var _this$context2 = this.context,
        getEditorState = _this$context2.getEditorState,
        onChange = _this$context2.onChange;
    onChange((0, _draftHelpers.deleteEntity)(entityKey, getEditorState()));
  },
  handleShowActions: function handleShowActions() {
    this.setState({
      showActionButtons: true
    });
  },
  handleHideActions: function handleHideActions(e) {
    var target = e.toElement || e.relatedTarget;

    if ((0, _utils.targetIsOrContainedByEl)("." + _constants.EMBED_COMPONENT_CLASSNAME, target) || (0, _utils.targetIsOrContainedByEl)("." + EMBED_OPTIONS_MENU_CLASSNAME, target)) {
      return;
    }

    this.setState({
      showActionButtons: false
    });
  },
  renderEmbedModal: function renderEmbedModal(enableCodeTab, embed, showEmbedModal, url) {
    if (!showEmbedModal) {
      return null;
    }

    return _react.default.createElement(_EmbedModal.default, {
      enableCodeTab: enableCodeTab,
      embed: embed,
      onClose: this.handleCloseModal,
      onSubmit: this.handleEditEmbed,
      url: url
    });
  },
  renderOptionButtons: function renderOptionButtons(showActionButtons) {
    if (!showActionButtons) {
      return _react.default.createElement("div", null);
    }

    return _react.default.createElement(_UIButtonGroup.default, {
      className: EMBED_OPTIONS_MENU_CLASSNAME,
      onMouseLeave: this.handleHideActions
    }, _react.default.createElement(_UIButton.default, {
      onClick: this.handleOpenModal,
      size: "extra-small",
      use: "tertiary"
    }, _react.default.createElement(_UIIcon.default, {
      name: "edit"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.embedPlugin.buttons.edit"
    })), _react.default.createElement(_UIButton.default, {
      onClick: this.handleRemoveEmbed,
      size: "extra-small",
      use: "tertiary"
    }, _react.default.createElement(_UIIcon.default, {
      name: "delete"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.embedPlugin.buttons.delete"
    })));
  },
  render: function render() {
    var _this$state = this.state,
        showEmbedModal = _this$state.showEmbedModal,
        showActionButtons = _this$state.showActionButtons;
    var _this$props2 = this.props,
        block = _this$props2.block,
        getAuth = _this$props2.blockProps.getAuth;
    var embedData = this.getEntityData(block.getEntityAt(0));
    var auth = getAuth();
    var enableCodeTab = auth.gates.has(_constants.OPEN_EMBED_GATE);
    var embedHtml = (0, _embedDataToHtml.default)(embedData);

    if (!embedHtml) {
      return null;
    }

    var url = this.getOriginalUrl(embedData);
    var classNames = (0, _classNames.default)(_constants.EMBED_COMPONENT_CLASSNAME, {
      active: showActionButtons
    });
    var needsInlineBlock = (0, _embed.hasEmbedDataWidthAndHeight)(embedData);
    return _react.default.createElement("div", {
      className: classNames,
      onMouseEnter: this.handleShowActions,
      onMouseLeave: this.handleHideActions
    }, this.renderEmbedModal(enableCodeTab, embedHtml, showEmbedModal, url), _react.default.createElement(_UITether.default, {
      attachmentHoriz: "right",
      attachmentVert: "bottom",
      classPrefix: "compose-draft-embed-action-buttons",
      content: this.renderOptionButtons(showActionButtons),
      constraints: [{
        to: 'scrollParent',
        pin: ['right']
      }],
      offsetHoriz: OFFSET_HORIZONTAL,
      offsetVert: OFFSET_VERTICAL,
      targetAttachmentHoriz: "right",
      targetAttachmentVert: "top"
    }, _react.default.createElement("div", {
      className: (0, _classNames.default)({
        'display-inline-block': needsInlineBlock
      }),
      dangerouslySetInnerHTML: {
        __html: (0, _embedDataToHtml.default)(embedData, true)
      }
    })));
  }
});

var _default = (0, _AtomicFocus.default)([_constants.EMBED_COMPONENT_CLASSNAME])(EmbedComponent);

exports.default = _default;
module.exports = exports.default;